import { Sticky } from 'components/video/sticky-video.component'
export default Sticky
